import { Flex } from '@chakra-ui/react';

import React, { PropsWithChildren } from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type ContainerProps = {
  label: string;
};

export const Container: React.FC<PropsWithChildren<ContainerProps>> = ({ children, label }) => {
  return (
    <Flex
      alignItems="flex-start"
      backgroundColor="white"
      borderColor={'blackAlpha.100'}
      borderWidth="1px"
      borderRadius="15px"
      flexDirection={'column'}
      width={['full']}
      minWidth={['full', 'full', 'full', '350px']}>
      <TextBlock as="div" fontSize="16px" padding={'20px'}>
        {label}
      </TextBlock>
      {children}
    </Flex>
  );
};
